import { COUNTRIES_CODES } from 'constants/countries'
import { i18n } from 'core/i18n'

const { getNamedVariablesValues, extractNamedVariables, formatTextNamed } = i18n

const { PT, NL, DE } = COUNTRIES_CODES

export const getIsFullProfitability = (originCountry = '') => {
    return ![NL, PT, DE].includes(originCountry)
}

export const getDepositOfferData = (contractNumber, offersData) => {
    return offersData && offersData[contractNumber] && offersData[contractNumber][0];
}

export const getNamedVariables = (key, values) => {
    const namedVariables = extractNamedVariables(key);
    const namedVariablesValues = getNamedVariablesValues(namedVariables, values);
    return namedVariablesValues;
}

const getValuesAndPoe = (legalTextValues) => {
    const initalValueReducer = {
        values: {},
        poe: {}
    }

    return Object.keys(legalTextValues).reduce((acc, key) => {
        if (legalTextValues[key].isPoEditorKey) {
            acc.poe[key] = legalTextValues[key].value
            return acc;
        }
        acc.values[key] = legalTextValues[key].value;
        return acc;
    }, initalValueReducer);
}

export const handleSimplifyObject = (depositLegalText) => {
    if (!depositLegalText.isFetched) return

    const { data: legalTextValues } = depositLegalText;
    const { values, poe } = getValuesAndPoe(legalTextValues)
    const translatedPoe = Object.keys(poe).reduce((acc, key) => {
        const namedVariablesValues = getNamedVariables(poe[key], values);
        acc[key] = formatTextNamed(poe[key], namedVariablesValues);
        return acc
    }, {});

    return { ...values, ...translatedPoe };
}
